<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    Detalji poruke
                  </h2>
                  <p class="card-big-info-desc">
                    Unesite detalje poruke
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger':
                        $v.systemMessageType.$invalid && $v.systemMessageType.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Tip poruke</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="systemMessageType"
                        :options="messageTypes"
                        placeholder="Izaberite tip poruke"
                      />
                      <form-error
                        :model="$v.systemMessageType"
                        :dirty="$v.$dirty"
                        label="Tip poruke"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Kompanija</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div>
                        <treeselect
                          v-model="companyId"
                          :options="companies"
                          placeholder="Izaberite kompaniju"
                          @select="handleCompanyChange"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.receiverIds.$invalid && $v.receiverIds.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Primaoci</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ has__error: $v.receiverIds.$anyError }">
                        <treeselect
                          v-model="receiverIds"
                          :multiple="companyId != 0"
                          :disabled="companyId == 0"
                          :options="users"
                          placeholder="Izaberite primaoca"
                      />
                      </div>
                      <form-error
                        :model="$v.receiverIds"
                        :dirty="$v.$dirty"
                        label="Primaoci"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.subject.$invalid && $v.subject.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naslov</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="subject"
                      />

                      <form-error
                        :model="$v.subject"
                        :dirty="$v.$dirty"
                        label="Naslov"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.content.$invalid && $v.content.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Sadržaj</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        class="form-control form-control-modern"
                        placeholder="Sadržaj"
                        v-model="content"
                        rows="6"
                      />
                      <form-error
                        :model="$v.content"
                        :dirty="$v.$dirty"
                        label="Sadržaj"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'SystemMessages' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.send }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import api from '@/services/api';
import FormError from "../shared/form-errors/FormError.vue";

import { translations } from "@/mixins";
import validations from "./validation-schema/add";

export default {
  name: "AddSystemMessage",
  mixins: [translations],
  validations,
  components: { Treeselect, FormError },
  data() {
    return {
      subject: "",
      receiverIds: [],
      companyId: null,
      systemMessageType: 1,
      content: "",
      sendToAll: false
    };
  },
  computed: {
    users() {
      if (this.companyId == null) return [];
      const loggedUserId = this.$store.getters.getLoggedUser.userId;
      
      const users = this.$store.getters.getUsers.filter((item) => item.id !=loggedUserId).map((item) => {
        return {
          id: item.id,
          label: `${item.firstName} ${item.lastName}`,
        };
      });

      if (this.companyId == 0) {
        return [
          {
            id: 0,
            label: 'Svi'
          },
          ...users
        ]
      }

      return users;
    },
    messageTypes() {
      return [
        {
          id: 1,
          label: "Informativni",
        },
        {
          id: 2,
          label: "Upozorenje",
        },
      ];
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    companies() {
      const companies = this.$store.getters.getCompanies.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
      
      return [{
        id: 0,
        label: 'Sve'
      }, ...companies];
    },
  },
  watch: {
    companyId(newCompanyId) {
      this.sendToAll = newCompanyId === 0;
    },
  },
  methods: {
    loadUsers({ callback, searchQuery }) {
      this.$store
        .dispatch("getUsers", {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          companyId: this.companyId,
          sortBy: "firstName",
        })
        .then(() => {
          callback(null, this.users);
        });
    },
    handleCompanyChange(company) {
      this.$store
        .dispatch("getUsers", {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: '',
          companyId: company.id,
          sortBy: "firstName",
        })
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { subject, receiverIds, systemMessageType, content, sendToAll } = this;
      api.createSystemMessage({ subject, receiverIds, systemMessageType, content, sendToAll })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'SystemMessages' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
  mounted() {
    this.companyId = null;
    this.$store.dispatch("getCompanies", {
      sortBy: "title",
      isSortAscending: true,
      retrieveAll: true,
    });
  },
};
</script>
